import React, { Suspense, useState, useEffect, useRef } from 'react'

import {
  Table as ReactTable,
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  flexRender,
} from '@tanstack/react-table'
import BulkModal from './BulkModal';

const MembersyncTable = ({
  data,
  columns,
  type
}) => {
    
  const [columnVisibility, setColumnVisibility] = useState({
    ID: false,
    inviteID: false,
    orgID: false
  });

  const [rowSelection, setRowSelection] = useState({})

  const table = useReactTable({
    columns,
    data,
    state: {
      columnVisibility,
      rowSelection
    },
    onColumnVisibilityChange: setColumnVisibility,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection
  })

  return (
    <div className="p-2 membersync-org-members-table">
    { type === 'member' ? 
      <>
        { tangibleFields.render({
          type: 'select',
          name: 'membersync-org-members-bulk',
          choices: {
            edit: 'edit'
          }
        }) }
        { table.getSelectedRowModel().rows.length !== 0 && <BulkModal
          selectedRows={table.getSelectedRowModel()}
          role="member"
        /> }
      </> 
    : '' }
    <table>
      <thead className="membersync-org-members-table-content-head-items" >
        {table.getHeaderGroups().map(headerGroup => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              header.id === 'memberID' || 
              header.id === 'licenseID' || 
              header.id === "groupPresetID" ||
              header.id === "licensePresetID" ? '' :
              <th key={header.id} className="membersync-org-members-table-item-cell" colSpan={header.colSpan} >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
              </th>
            ))}
          </tr>
        ))}

      </thead>
      <tbody className="membersync-org-members-table-content-body-items" >
        {table.getRowModel().rows.map(row => (
          <tr key={row.id}>
            {row.getVisibleCells().map(cell => (
              cell.column.id === 'memberID' ||
              cell.column.id === 'licenseID'||
              cell.column.id === "groupPresetID" ||
              cell.column.id === "licensePresetID" ? '' :
              <td key={cell.id} className={"membersync-org-members-table-item-cell-" + cell.column.id} >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        {table.getFooterGroups().map(footerGroup => (
          <tr key={footerGroup.id}>
            {footerGroup.headers.map(header => (
              <th key={header.id}>
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.footer,
                      header.getContext()
                    )}
              </th>
            ))}
          </tr>
        ))}
      </tfoot>
    </table>
    <div className="membersync-org-members-table-footer" >
      <span className="membersync-org-members-table-footer-counter" >
        {data.length} items
      </span>
      <input
        value="<<"
        onClick={() => table.setPageIndex(0)}
        type='button'
        disabled={!table.getCanPreviousPage()}
      />
      <input
        value="<"
        onClick={() => table.previousPage()}
        type='button'
        disabled={!table.getCanPreviousPage()}
      />
      <span className="flex items-center gap-1 membersync-org-members-table-search-page">
        <span className="tms-active-licenses-search-page-content" >
          <span className="flex items-center gap-1">
            <input
              type="text"
              value={table.getState().pagination.pageIndex + 1 }
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                table.setPageIndex(page)
                const targetLength = e.target.value.length * 10
                if ( targetLength >= 50 && targetLength < 70 ) {
                  e.target.style.width = '70px'
                } else {
                  e.target.style.width = '50px'
                }
                if ( targetLength >= 70 ) e.target.style.width = targetLength + 'px'
              }}
              className="border p-1 rounded w-16 membersync-org-members-table-search-page-input"
            />
          </span>
          of{' '}
          {table.getPageCount()}
        </span>
      </span>
      <input
        value=">"
        onClick={() => table.nextPage()}
        type='button'
        disabled={!table.getCanNextPage()}
      />
      <input
        value=">>"
        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
        type='button'
        disabled={!table.getCanNextPage()}
      />
    </div>
    <div className="h-4" />
  </div>
  );
};

export default MembersyncTable;